module.exports = __webpack_public_path__ + "static/scale-model-of-circa-21-speakeasy-in-davenport-iowa-1c808ac3a95475ecddc6b504a3856330.png";